export const CATEGORY_GROUP = 'categoryGroup';
export const APPAREL = 'Apparel';
export const ACCESSORIES = 'Accessories';
export const BATH_AND_BEAUTY = 'Bath & Beauty';
export const FOOTWEAR = 'Footwear';
export const HOUSEWARES = 'Home';
